import React, { useState } from "react";

//Importar íconos de Material UI.
import { ForwardToInbox, Construction, Send } from '@mui/icons-material/';
import useNewRutaVisitada from "../hooks/useNewRootVisited";
import TableClients from "../components/Remates/TableClients";
import ModalSendMessageMass from "../components/common/Modal/ModalSendMessageMass";

const Remates = ({ ruta, onChangeRuta }) => {

  const [cantEnviar, setCantEnviar] = useState(50); //Estado para guardar la cantidad de mensajes a ser enviados.
  const [openModal, setOpenModal] = useState(false); //Estado para abrir el modal y confirmar el envío de mensajes.
  useNewRutaVisitada(ruta, onChangeRuta);

  return (
    <div className="container-remates__layout">

      <div className="container-section-title">
        <ForwardToInbox sx={{ fontSize: "50px", marginRight: "15px", color: "var(--color-degraded-by-company)" }}/>
        <div className="container-section-title__title">
        <h3 className="title-section">Envíos Masivos</h3>
        <span className="description-section">Comunícate con todos tus clientes de forma rápida.</span>
        </div>
      </div>

      <div className="container-date-with-actions">
        <div className="container-title-with-data">
          <span className="titleData-title">PRÓXIMO REMATE: </span>
          <span className="titleData-data">06/07/2024 </span>
        </div>
        <div className="container-title-with-data">
          <span className="titleData-title">PENDIENTES: </span>
          <span className="titleData-data">6417 </span>
        </div>
        <div className="container-title-with-data send-msj">
          <span className="titleData-title">CANT. ENVIAR: </span>
          <input className="container-input-cantidad" placeholder="Ingresar Cantidad..." onChange={(e) => setCantEnviar(e.target.value)}/>
          <button className="send-msj-btn" onClick={() => setOpenModal(true)}> <Send sx={{ marginRight: "10px" }}/> Enviar Mensajes</button>
        </div>
      </div>

      <TableClients />

      {/*------Modal para confirmar envío de mensaje------*/}
      <ModalSendMessageMass setOpenModal={setOpenModal} openModal={openModal}/>

    </div>
  );
};

export default Remates;